<template>
  <b-img
    v-bind="attrs"
    v-on="$listeners"
    v-lazy="placeholderUrl"
    @click="handlePreview"
  />
</template>

<script>
export default {
  name: 'BrbThumbnail',
  inheritAttrs: false,
  props: {
    src: { type: String, default: null },
    thumbor: { type: Boolean, default: true },
    format: { type: String, default: 'webp' },
    fitIn: { type: Boolean, default: true },
    width: { type: [Number, String], default: null },
    height: { type: [Number, String], default: null },
    lazy: { type: Boolean, default: false },
    fluid: { type: Boolean, default: true },
    effects: { type: Object, default: null },
    showNoImage: { type: Boolean, default: true },
    placeholder: {
      type: String,
      default: function () {
        return this.$config.files.imagePlaceholderUrl
      }
    },
    noImageUrl: {
      type: String,
      default() {
        return this.$config.files.noImageUrl
      }
    },
    showImagePreview: Boolean,
    imagePreviewImages: {
      type: [String, Array],
      default: null
    }
  },
  data() {
    return {
      webpBrowserMinVersion: {
        Ie: 999,
        Chrome: 31,
        Firefox: 64,
        Edge: 17,
        Safari: 14
      }
    }
  },
  computed: {
    attrs() {
      const attrs = {
        src: this.mediaSrc,
        width: this.width,
        height: this.height,
        fluid: this.fluid,
        ...this.$attrs
      }
      return attrs
    },
    mediaSrc() {
      if (!this.src) {
        if (this.showNoImage) return this.noImageUrl
        return null
      }

      // if src is an external url dont use thumbor
      if (this.src.startsWith('http')) return this.src

      if (
        this.thumbor &&
        this.$config.files &&
        this.$config.files.thumbor &&
        this.$config.files.thumbor.enabled
      ) {
        return this.thumbUrl
      }

      return this.staticUrl
    },
    placeholderUrl() {
      return this.lazy && this.placeholder
    },
    staticUrl() {
      return this.$config.files.createStaticUrl(this.src)
    },
    webpCompatible() {
      const browser = this.$browserDetect.meta.name
      const browserVersion = this.$browserDetect.meta.version.split('.')[0]
      return browserVersion > this.webpBrowserMinVersion[browser]
    },
    thumborConfig() {
      return {
        src: this.src,
        fitIn: this.fitIn,
        width: this.width,
        height: this.height,
        effects: this.effects || {},
        format: this.format,
        webpCompatible: this.webpCompatible
      }
    },
    thumbUrl() {
      return this.$config.files.thumbor.createUrl(this.thumborConfig)
    }
  },
  methods: {
    handlePreview() {
      if (this.showImagePreview) {
        let images = []

        if (this.imagePreviewImages) {
          if (typeof this.imagePreviewImages === 'string') {
            images = this.imagePreviewImages.split(',')
          } else {
            images = this.imagePlaceholderUrl
          }
        } else {
          images = [this.src.startsWith('http') ? this.src : this.staticUrl]
        }
        this.$brbImagePreview({
          images
        })
      }
    }
  }
}
</script>
